import ArrowRepeatIcon from 'assets/icons/arrow-repeat.svg?component'
import Button from 'components/UI/Buttons/Button'
import Typography from 'components/UI/Typography'
import { useTranslation } from 'react-i18next'
import tw from 'twin.macro'

const RetryDdocs = ({ isLoading, onRetry }: { isLoading: boolean; onRetry: () => void }) => {
  const { t } = useTranslation()

  return (
    <div tw='pt-5 px-5'>
      <Typography variant='body' weight='bold'>
        {t('flow-digital-doc')}
      </Typography>
      <Typography variant='subbody' text twStyle={tw`text-grey-dark mt-4`}>
        {t('flow-confirm-sms')}
      </Typography>
      <Button variant='primary' loading={isLoading} twStyle={tw`mt-4`} icon={<ArrowRepeatIcon />} onClick={onRetry}>
        <Typography variant='body' weight='bold' twStyle={tw`text-white`}>
          {t('retry')}
        </Typography>
        <Typography variant='caption' twStyle={tw`text-white `}>
          {t('send-cd')}
        </Typography>
      </Button>
    </div>
  )
}

export default RetryDdocs
